<template>
  <el-image
    fit="cover"
    class="screen"
    :src="src"
    lazy
    @click="$emit('click')"
  >
    <div slot="error" class="bundle-image">
      <img :src="bundleImage(this.application.bundleId)" />
    </div>
  </el-image>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    application: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    src () {
      if (this.application.state === 'stopped') {
        return
      }
      return axios.defaults.baseURL + 'engine/screen/' + this.application.id + '.jpg?cache=' + this.application.screen
    }
  }
}
</script>

<style lang="scss">
  .screen {
    .bundle-image {
      width: 100%;
      height: 115px;

      img {
        width: 100%;
        height: 100%;
        object-fit: scale-down;
        object-position: center;
      }
    }

    > img {
      object-position: top;
    }
  }
</style>
